// 设备通道：列表 + 改名
// 反编译 + 文档:
//   GET base /device/channel_list?device_auto_id=...   通道列表（含 alias/upload_rate/preview_pic）
//   GET base /device/channel_edit?device_auto_id=...&channel_id=...&alias=...  通道改名
import { callInternal } from './internal.js';

export interface Channel {
	device_auto_id: string;
	channel_id: string | number;
	device_id?: string | number | null;
	device_sn?: string | number | null;
	sn?: string | number | null;
	serial_no?: string | number | null;
	device_name?: string | null;
	name?: string | null;
	store_id?: string | number | null;
	alias?: string | null;
	upload_rate?: string | null;
	preview_pic?: string | null;
	[k: string]: unknown;
}

export async function fetchChannels(deviceAutoId: string | number): Promise<Channel[]> {
	const res = await callInternal<Channel[]>({
		short_name: 'base',
		action: '/device/channel_list',
		method: 'GET',
		query: { device_auto_id: String(deviceAutoId) },
		av: '1',
	});
	if (res.code !== 0 || !Array.isArray(res.data)) return [];
	return res.data;
}

export async function renameChannel(opts: {
	deviceAutoId: string | number;
	channelId: string | number;
	alias: string;
}): Promise<{ ok: boolean; msg?: string }> {
	const res = await callInternal({
		short_name: 'base',
		action: '/device/channel_edit',
		method: 'GET',
		query: {
			device_auto_id: String(opts.deviceAutoId),
			channel_id: String(opts.channelId),
			alias: opts.alias,
		},
		av: '1',
	});
	return { ok: Number(res.code) === 0, msg: res.msg };
}
